import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(private http: HttpClient, private apiService: ApiService) { }

  apiUrl = `${this.apiService.apiUrl}/exports`;

  exportCustomerPageData(pageId: string, customerId: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.apiUrl}/customer/${customerId}/page/${pageId}`, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
